const ServicesList = () => {
  const services = [
    {
      id: 'management',
      icon: 'ri-line-chart-line',
      title: 'Management & Operations Consulting',
      description:
        'Comprehensive practice management solutions that streamline clinical and administrative operations.',
      details: [
        'Practice workflow optimization and efficiency improvement',
        'Administrative burden reduction strategies',
        'Operational model design for scalability',
        'Performance metrics and KPI development',
      ],
      forWhom: 'Private practices, clinical groups, and multi-provider organizations',
      outcomes:
        'Reduced operational costs, improved staff productivity, enhanced patient throughput',
    },
    {
      id: 'growth',
      icon: 'ri-rocket-line',
      title: 'Practice Growth & Scaling Strategy',
      description:
        'Strategic frameworks for sustainable practice expansion and patient acquisition.',
      details: [
        'Market analysis and growth opportunity identification',
        'Patient acquisition and retention strategies',
        'Service line expansion planning',
        'Multi-location practice development',
      ],
      forWhom: 'Established practices ready to scale and expand market presence',
      outcomes:
        'Increased patient volume, expanded service offerings, sustainable revenue growth',
    },
    {
      id: 'workflow',
      icon: 'ri-flow-chart',
      title: 'Administrative Workflow Optimization',
      description:
        'Redesign administrative processes to eliminate inefficiencies and reduce manual tasks.',
      details: [
        'Process mapping and bottleneck identification',
        'Workflow redesign and standardization',
        'Staff training and change management',
        'Documentation and compliance optimization',
      ],
      forWhom: 'Practices experiencing administrative inefficiencies and staff burnout',
      outcomes:
        'Streamlined operations, reduced administrative time, improved staff satisfaction',
    },
    {
      id: 'digital',
      icon: 'ri-computer-line',
      title: 'Digital Transformation & IT Integration',
      description:
        'Modernize your digital infrastructure with strategic technology implementation.',
      details: [
        'Technology needs assessment and roadmap development',
        'System integration and interoperability planning',
        'Cloud migration and infrastructure modernization',
        'Cybersecurity and compliance framework implementation',
      ],
      forWhom: 'Practices seeking to modernize legacy systems and improve digital capabilities',
      outcomes:
        'Enhanced operational efficiency, improved data accessibility, reduced IT costs',
    },
    {
      id: 'crm',
      icon: 'ri-customer-service-2-line',
      title: 'CRM Implementation & Workflow Design',
      description:
        'Deploy customer relationship management platforms for patient inquiries, referrals, and follow-ups.',
      details: [
        'CRM platform selection and customization',
        'Patient journey mapping and touchpoint optimization',
        'Automated follow-up and engagement workflows',
        'Referral management and tracking systems',
      ],
      forWhom: 'Practices looking to improve patient communication and relationship management',
      outcomes:
        'Improved patient engagement, increased referral conversion, enhanced patient satisfaction',
    },
    {
      id: 'cms',
      icon: 'ri-pages-line',
      title: 'Website CMS Strategy & Content Architecture',
      description:
        'Implement content management systems for managing and scaling web content effectively.',
      details: [
        'CMS platform evaluation and selection',
        'Content architecture and information hierarchy design',
        'Content workflow and governance framework',
        'SEO-optimized content strategy development',
      ],
      forWhom: 'Practices needing scalable website management and content control',
      outcomes:
        'Improved website performance, easier content updates, enhanced online presence',
    },
    {
      id: 'ehr',
      icon: 'ri-hospital-line',
      title: 'Clinical Systems Optimization',
      description:
        'Optimize EHR and practice management platforms for maximum efficiency and usability.',
      details: [
        'EHR workflow optimization and customization',
        'Practice management system configuration',
        'Clinical documentation improvement',
        'System integration and data migration',
      ],
      forWhom: 'Practices struggling with EHR inefficiencies and documentation burden',
      outcomes:
        'Reduced documentation time, improved clinical workflow, enhanced data quality',
    },
    {
      id: 'engagement',
      icon: 'ri-user-heart-line',
      title: 'Patient Engagement & Digital Intake Systems',
      description:
        'Implement patient engagement platforms and digital intake workflows to enhance experience.',
      details: [
        'Digital intake form design and implementation',
        'Patient portal optimization and adoption strategies',
        'Automated appointment reminders and confirmations',
        'Patient education and communication tools',
      ],
      forWhom: 'Practices seeking to improve patient experience and reduce no-shows',
      outcomes:
        'Increased patient satisfaction, reduced no-show rates, improved data collection',
    },
    {
      id: 'telehealth',
      icon: 'ri-video-chat-line',
      title: 'Teleconsultation Platform Integration',
      description:
        'Integrate teleconsultation platforms to expand service delivery and patient access.',
      details: [
        'Telehealth platform selection and implementation',
        'Virtual care workflow design and optimization',
        'Compliance and reimbursement strategy',
        'Staff training and patient adoption programs',
      ],
      forWhom: 'Practices expanding into virtual care delivery models',
      outcomes:
        'Expanded patient access, increased appointment capacity, new revenue streams',
    },
    {
      id: 'revenue',
      icon: 'ri-money-dollar-circle-line',
      title: 'Revenue Cycle & Billing Workflow Optimization',
      description:
        'Optimize revenue cycle management and billing workflows to maximize collections.',
      details: [
        'Revenue cycle assessment and gap analysis',
        'Billing workflow optimization and automation',
        'Denial management and appeals process improvement',
        'Financial reporting and analytics implementation',
      ],
      forWhom: 'Practices experiencing revenue leakage and billing inefficiencies',
      outcomes:
        'Increased collections, reduced days in AR, improved cash flow',
    },
    {
      id: 'marketing',
      icon: 'ri-megaphone-line',
      title: 'Marketing Strategy & SEO Execution',
      description:
        'Develop and execute comprehensive marketing strategies to drive patient acquisition.',
      details: [
        'Marketing strategy development and planning',
        'Brand positioning and messaging framework',
        'Multi-channel campaign design and execution',
        'Marketing performance measurement and optimization',
      ],
      forWhom: 'Practices seeking to increase visibility and attract new patients',
      outcomes:
        'Increased brand awareness, higher patient acquisition, improved ROI',
    },
    {
      id: 'seo',
      icon: 'ri-search-line',
      title: 'Local Search Optimization & Online Visibility',
      description:
        'Improve local search rankings and online visibility to attract more patients.',
      details: [
        'Local SEO audit and optimization',
        'Google Business Profile optimization',
        'Online reputation management',
        'Local citation building and directory management',
      ],
      forWhom: 'Practices competing for local patient search traffic',
      outcomes:
        'Higher search rankings, increased website traffic, more patient inquiries',
    },
    {
      id: 'performance',
      icon: 'ri-speed-line',
      title: 'Website Performance Optimization & Conversion Tracking',
      description:
        'Optimize website performance and implement conversion tracking for better results.',
      details: [
        'Website speed and performance optimization',
        'Conversion rate optimization and A/B testing',
        'Analytics implementation and goal tracking',
        'User experience and interface improvements',
      ],
      forWhom: 'Practices with underperforming websites and low conversion rates',
      outcomes:
        'Faster website load times, higher conversion rates, better user experience',
    },
    {
      id: 'automation',
      icon: 'ri-robot-line',
      title: 'Workflow Automation Across Clinical Operations',
      description:
        'Automate scheduling, intake, billing, and communications to reduce manual tasks.',
      details: [
        'Process automation opportunity identification',
        'Automation tool selection and implementation',
        'Workflow integration and testing',
        'Staff training and change management',
      ],
      forWhom: 'Practices seeking to reduce manual tasks and improve efficiency',
      outcomes:
        'Reduced manual work, fewer errors, improved staff productivity',
    },
    {
      id: 'analytics',
      icon: 'ri-dashboard-line',
      title: 'Performance Analytics & Reporting Dashboards',
      description:
        'Implement analytics and reporting dashboards for performance visibility and insights.',
      details: [
        'KPI identification and dashboard design',
        'Data integration and visualization',
        'Automated reporting and alerts',
        'Data-driven decision-making frameworks',
      ],
      forWhom: 'Practices needing better visibility into operational and financial performance',
      outcomes:
        'Improved decision-making, proactive issue identification, performance optimization',
    },
  ];

  return (
    <section className="py-24 bg-gray-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="space-y-12">
          {services.map((service, index) => (
            <div
              key={service.id}
              id={service.id}
              className={`bg-white rounded-3xl p-10 lg:p-12 shadow-lg hover:shadow-2xl transition-all duration-300 ${
                index % 2 === 0 ? '' : ''
              }`}
            >
              <div className="flex flex-col lg:flex-row gap-8">
                <div className="lg:w-1/4">
                  <div className="w-16 h-16 flex items-center justify-center mb-6">
                    <i className={`${service.icon} text-5xl text-gold`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-navy-primary mb-4">
                    {service.title}
                  </h3>
                  <p className="text-sm text-charcoal leading-relaxed">
                    {service.description}
                  </p>
                </div>

                <div className="lg:w-3/4 space-y-6">
                  <div>
                    <h4 className="text-sm uppercase tracking-widest text-gold mb-3 font-semibold">
                      What We Do
                    </h4>
                    <ul className="space-y-2">
                      {service.details.map((detail, idx) => (
                        <li
                          key={idx}
                          className="flex items-start text-sm text-charcoal"
                        >
                          <i className="ri-check-line text-gold text-lg mr-3 mt-0.5"></i>
                          <span>{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-gray-bg/50 rounded-xl p-6">
                      <h4 className="text-sm uppercase tracking-widest text-gold mb-3 font-semibold">
                        Who It's For
                      </h4>
                      <p className="text-sm text-charcoal leading-relaxed">
                        {service.forWhom}
                      </p>
                    </div>

                    <div className="bg-gray-bg/50 rounded-xl p-6">
                      <h4 className="text-sm uppercase tracking-widest text-gold mb-3 font-semibold">
                        Tangible Outcomes
                      </h4>
                      <p className="text-sm text-charcoal leading-relaxed">
                        {service.outcomes}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesList;